import React from 'react';

const Loading = () => {
  return (
    <div className='w-full h-full flex items-center justify-center bg-primary/40'>
      لطفا منتظر بمانید...
    </div>
  );
};

export default Loading;
